import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaRobot, FaBook } from 'react-icons/fa';
import { IoMdFolderOpen, IoMdDownload, IoMdTime } from 'react-icons/io';
import { BsFillMortarboardFill } from 'react-icons/bs';
import "../covfile/Home.css";
import { FaBookOpen } from "react-icons/fa6";

function Home() {
    const navigate = useNavigate();

    const cards = [
                // {
        //     id: 1,
        //     title: 'AI Tools',
        //     description: 'Інструменти для роботи з AI',
        //     icon: <FaRobot />,
        //     path: '/1'
        // },
        // {
        //     id: 2,
        //     title: 'Cases',
        //     description: 'Робота з кейсами',
        //     icon: <IoMdFolderOpen />,
        //     path: '/2'
        // },
        {
            id: 3,
            title: 'Syrve Install',
            description: 'Відслідковування встановлення Syrve Office/Syrve Chain',
            icon: <IoMdDownload />,
            path: '/InstallSyrve'
        },
        {
            id: 4,
            title: 'Time Tracker',
            description: 'Відслідковання і керування часом задач',
            icon: <IoMdTime />,
            path: '/TimeTracker'
        },
        {
            id: 5,
            title: 'База Знань',
            description: 'Офіційна документація і база знань',
            icon: <FaBook />,
            path: '/KnowledgeBase'  // змініть на відповідний шлях
        },
        {
            id: 6,
            title: 'Сайт Матриці',
            description: 'Платформа для проходження екзаменів',
            icon: <BsFillMortarboardFill />,
            path: '/MatrixSite'  // змініть на відповідний шлях
        },
        {
            id: 7,
            title: 'DAO Instruction Hub',
            description: 'Центр інструкцій для інструментів DAO',
            icon: <FaBookOpen />,
            path: 'https://dao-instruction-hub.valyksalnykov.chatgpt.site/',
            isExternal: true  // додаємо прапорець для зовнішніх посилань
        },
        {
            id: 8,
            title: 'DAO Install Files',
            description: 'Сторінка для завнтаження файлів',
            icon: <IoMdDownload />,
            path: '/FilesDownloadPage',
   
        }
    ];

    const handleCardClick = (card) => {
        if (card.isExternal) {
            // Для зовнішніх посилань відкриваємо в новій вкладці
            window.open(card.path, '_blank', 'noopener,noreferrer');
        } else {
            // Для внутрішніх маршрутів використовуємо navigate
            navigate(card.path);
        }
    };

    return (
        <div className="home-container">
            <div className="home-content">
                <h1 className="main-title" style={{marginTop: "50px"}}>DAO Hub</h1>
                <h2 className="subtitle">Ваш центр керування додатками і інструментами</h2>
                
                <div className="cards-grid">
                    {cards.map((card) => (
                        <div 
                            key={card.id} 
                            className="card"
                            onClick={() => handleCardClick(card)}
                        >
                            <div className="card-icon">{card.icon}</div>
                            <h3 className="card-title">{card.title}</h3>
                            <p className="card-description">{card.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Home;